import { getLocalApi } from 'app/shared/api/localApi';
import apiConfig from 'app/api/apiConfig.json';
import { ApiErrors } from 'app/shared/api/ApiErrors';

export async function saveTaxRule(id: number, payload: Record<string, unknown>): Promise<{ ok: boolean; message?: string }> {
  const localApi = await getLocalApi();
  const template = (apiConfig as Record<string, string>).tax_rules_put;
  if (!template) {
    return { ok: false, message: 'Tax rules save API is not configured' };
  }
  const url = template.replace('{id}', String(id));
  const response = await localApi.call(url, 'PUT', JSON.stringify(payload));
  if (!response) {
    return { ok: false, message: 'No response from server' };
  }
  const text = await response.text().catch(() => '');
  let data: any = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }
  const errors = ApiErrors.extractAllErrors(data, response, 'Failed to save tax rule');
  const isFailed = data?.isFailed === true || data?.isSuccess === false;
  if (!response.ok || (isFailed && errors.length > 0)) {
    return { ok: false, message: ApiErrors.formatErrors(errors) };
  }
  return { ok: true };
}